import {H4Italic} from "@/elements/semanticWrappers";
import {Text} from "@/elements/text";
import type {SectionQuote} from "@/generated/api";
import SectionWrapper from "@/layouts/SectionWrapper";
import {CitationWrapper} from "./styles";

interface B3CitationProps {
  sectionData: SectionQuote;
  isFirstSection?: boolean;
  isLastSection?: boolean;
  id?: string;
}

const B3Citation = ({
  sectionData,
  isFirstSection,
  isLastSection,
  id,
}: B3CitationProps) => {
  const {bg_color, quote, text} = sectionData;

  return (
    <SectionWrapper
      id={id}
      backgroundColor={bg_color}
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
    >
      <CitationWrapper>
        <H4Italic>{quote}</H4Italic>

        <Text styles={{marginTop: 14}} type={"bodyBold"}>
          {text}
        </Text>
      </CitationWrapper>
    </SectionWrapper>
  );
};

export default B3Citation;
